export const HumanReadableTokenName: Record<string, string | undefined> = {
  USDC: 'USD Coin',
  USDT: 'Tether',
  DAI: 'Dai Stablecoin',
  WETH: 'Ether',
  WBTC: 'Bitcoin',
  ptETH: 'Ether',
  ptBTC: 'Bitcoin',
  zUSDC: 'USD Coin',
  ptUSDT: 'Tether',
  ptUSD: 'Tether',
  ptDAI: 'Dai Stablecoin',
}
